// frontend/src/services/marketplace/normalizeMarketplaceListing.js

const PLACEHOLDER_IMAGE = "/Logos/placeholder-item.png";

function normalizeImages(images) {
  if (!Array.isArray(images)) return [];

  return images
    .filter((image) => image?.image_url)
    .sort((a, b) => Number(a?.position ?? 0) - Number(b?.position ?? 0))
    .map((image) => ({
      id: image.id ?? null,
      imageUrl: image.image_url,
      position: image.position ?? null,
      isPrimary: Boolean(image.is_primary),
    }));
}

export default function normalizeMarketplaceListing(row) {
  if (!row) return null;

  const imageObjects = normalizeImages(row.images);
  const imageUrls = imageObjects.map((image) => image.imageUrl);

  return {
    listingId: row.listing_id,
    listingType: row.listing_type,
    title: row.title || "Unnamed Item",
    brand: row.brand || "",
    setName: row.set_name || "",
    year: row.year ?? "",
    description: row.description || "",
    attributes: row.attributes || {},

    priceAmount: row.price_amount,
    currency: row.currency || "USD",
    listingQuantity: row.listing_quantity ?? 1,
    quantityAvailable: row.quantity_available ?? 0,

    acceptsOffers: Boolean(row.accepts_offers),
    minimumOfferAmount: row.minimum_offer_amount ?? null,

    inventoryId: row.inventory_id,
    itemId: row.item_id ?? null,
    categoryId: row.category_id ?? null,
    subcategoryId: row.subcategory_id ?? null,
    condition: row.condition || "",

    imageObjects,
    images: imageUrls,
    primaryImage: imageUrls[0] || PLACEHOLDER_IMAGE,

    shop: {
      id: row.shop_id,
      slug: row.shop_slug || "",
      name: row.shop_name || "",
      logoUrl: row.shop_logo_url || null,
      isPlatformShop: Boolean(row.is_platform_shop),
    },

    seller: {
      accountId: row.seller_account_id,
      displayName: row.seller_display_name || "Seller",
      contactUserId: row.seller_contact_user_id ?? null,
    },

    featured: Boolean(row.featured),
    platformRankBoost: row.platform_rank_boost ?? 0,
    publishedAt: row.published_at ?? null,
  };
}

export { PLACEHOLDER_IMAGE };
